import { render, staticRenderFns } from "./StudentInvoiceSummary.vue?vue&type=template&id=764e01d2&scoped=true"
import script from "./StudentInvoiceSummary.vue?vue&type=script&lang=js"
export * from "./StudentInvoiceSummary.vue?vue&type=script&lang=js"
import style0 from "./StudentInvoiceSummary.vue?vue&type=style&index=0&id=764e01d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e01d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764e01d2')) {
      api.createRecord('764e01d2', component.options)
    } else {
      api.reload('764e01d2', component.options)
    }
    module.hot.accept("./StudentInvoiceSummary.vue?vue&type=template&id=764e01d2&scoped=true", function () {
      api.rerender('764e01d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/StudentInvoiceSummary.vue"
export default component.exports